import styled from 'styled-components';

export default styled.ul`
  display: block;
  background: white;
  padding: 10px 0;
  
  font-family: 'Noto Sans', serif;
  font-size: 16px;

  margin: 0;
`;
